module.exports = __webpack_public_path__ + "static/media/add-icon.1f868fbb.svg";